export const SELECTED_KIT_PRODUCT_ID = "selected_kit_product_id";
export const SELECTED_DEVICE_PRODUCT_ID = "selected_device_product_id";